import { Reaction } from './reaction';
import { WardError } from '../ward-error';

export class ThrowReaction implements Reaction {
  react(wardError: WardError): void {
    if (wardError == null) {
      throw new ReferenceError('wardError cannot be null or undefined');
    }
    throw new Error(wardError.error);
  }
}
